import {cva, type VariantProps} from 'class-variance-authority'
import {HTMLAttributes} from "vue";
import {GridItem} from "@/shared/components/ui/helper";
import {Validation} from "@/shared/graphql/types";
import {FormValidationError, FormValidationSource} from "@/shared/components/ui/form2";

export {default as Form} from '../Form.vue'
export {default as FormAutocomplete} from './FormAutocomplete.vue'
export {default as FormCheckbox} from './FormCheckbox.vue'
export {default as FormCheckboxCard} from './FormCheckboxCard.vue'
export {default as FormCountrySelect} from './FormCountrySelect.vue'
export {default as FormDatePicker} from './FormDatePicker.vue'
export {default as FormDateRangePicker} from './FormDateRangePicker.vue'
export {default as FormInput} from './FormInput.vue'
export {default as FormRadioButtonGroup} from './FormRadioButtonGroup.vue'
export {default as FormRadioCardGroup} from './FormRadioCardGroup.vue'
export {default as FormSelect} from './FormSelect.vue'
export {default as FormSlider} from './FormSlider.vue'
export {default as FormSwitch} from './FormSwitch.vue'
export {default as FormTextarea} from './FormTextarea.vue'
export {default as FormTextEditor} from './FormTextEditor.vue'
export {default as FormTimeInput} from './FormTimeInput.vue'


export interface FormItemProps extends GridItem {
    label?: string,
    description?: string,
    disabled?: boolean,
    required?: boolean,
    error?: FormValidationError | null,
    class?: HTMLAttributes['class'],
    elementClass?: HTMLAttributes['class'],
}

export const formVariants = cva(
    'grid gap-default',
    {
        variants: {
            columns: {
                1: 'grid-cols-1',
                2: 'grid-cols-2',
                3: 'grid-cols-3',
                4: 'grid-cols-4',
                5: 'grid-cols-5',
                6: 'grid-cols-6',
            }
        },
        defaultVariants: {
            columns: 1,
        },
    },
)
export type FormVariants = VariantProps<typeof formVariants>

export const switchVariants = cva(
    'flex flex-row items-center justify-between',
    {
        variants: {
            variant: {
                'border': 'rounded-lg border p-4',
                'no-border': '',
            }
        },
        defaultVariants: {
            variant: 'border',
        },
    },
)
export type SwitchVariants = VariantProps<typeof switchVariants>

export const customerContactSelectVariants = cva(
    'grid gap-default',
    {
        variants: {
            columns: {
                1: 'grid-cols-1',
                2: 'grid-cols-2',
            }
        },
        defaultVariants: {
            columns: 1,
        },
    },
)
export type CustomerContactSelectVariants = VariantProps<typeof customerContactSelectVariants>

export const checkboxVariant = cva(
    '',
    {
        variants: {
            variant: {
                'default': '',
                'pill': 'border-2 border-primary',
            }
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)
export type CheckboxVariant = VariantProps<typeof checkboxVariant>


/**
 * @deprecated when using from 2 you can use validationToErrors2
 */
export function validationToErrors(validation: Validation): object {
    const parsedErrors = {};
    validation.fieldErrors.forEach((error) => {
        parsedErrors[error.path] = error.message;
    });
    return parsedErrors;
}


export function validationToErrors2(validation: Validation): Record<string, FormValidationError> {
    const parsedErrors = {};
    validation.fieldErrors.forEach((error) => {
        parsedErrors[error.path] = {label: error.message, source: FormValidationSource.SERVER} as FormValidationError;
    });
    return parsedErrors;
}

export type ComboBoxSuggestion = {
    value: string|number
    label: string
}